module.exports = __webpack_public_path__ + "img/tick.66c62598.png";